<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentTeam /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentTeam from '@/components/worker/dashboard/modules/team/ContentTeam.vue'

export default 
{
  name: 'Team',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentTeam
  }
}
</script>
<style>


</style>